import { ReactElement } from "react";
import {
  ToolsIcon,
  LayoutGridAddIcon,
  SettingsIcon,
  SettingsAdjustHorizontalIcon,
  PaletteIcon,
  FoldersIcon,
} from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { GameProvider } from "../../../contexts/game/GameContext";
import { ProjectNavigation } from "./ProjectNavigation";
import { ProjectProvider } from "../../../contexts/project/ProjectContext";
import { ProjectSettings } from "./ProjectSettings";
import { StepProvider } from "../../../contexts/step/StepContext";

import styles from "./ProjectView.module.scss";

export interface Step {
  title: string;
  icon: ReactElement;
}

export const ProjectView = () => {
  const { t } = useTranslation("project");

  const steps: Step[] = [
    {
      title: t("navigation.steps.configureProject"),
      icon: <ToolsIcon />,
    },
    {
      title: t("navigation.steps.addGames"),
      icon: <LayoutGridAddIcon />,
    },
    {
      title: t("navigation.steps.gameSettings"),
      icon: <SettingsIcon />,
    },
    {
      title: t("navigation.steps.advancedSettings"),
      icon: <SettingsAdjustHorizontalIcon />,
    },
    {
      title: t("navigation.steps.customizeVisuals"),
      icon: <PaletteIcon />,
    },
    {
      title: t("navigation.steps.gameManagement"),
      icon: <FoldersIcon />,
    },
  ];

  return (
    <div className={styles.projectView}>
      <ProjectProvider>
        <GameProvider>
          <StepProvider>
            <ProjectNavigation steps={steps} />
            <ProjectSettings />
          </StepProvider>
        </GameProvider>
      </ProjectProvider>
    </div>
  );
};
